"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ChargeCardStatus = void 0;
var ChargeCardStatus;
(function (ChargeCardStatus) {
    /** Can be used everywhere, including roaming */
    ChargeCardStatus["ACTIVE"] = "Active";
    /** Has been blocked, can no longer be used for charging on any network */
    ChargeCardStatus["BLOCKED"] = "Blocked";
    /** Has been activated and can be used on own charge point, but not yet enabled for roaming */
    ChargeCardStatus["WAIT_FOR_OCPI_ACTIVATION"] = "WaitForOcpiActivation";
    /** Has not yet been activated */
    ChargeCardStatus["INACTIVE"] = "Inactive";
})(ChargeCardStatus || (exports.ChargeCardStatus = ChargeCardStatus = {}));
